import DashboardCircleIconSolid from '@/components/icons/DashboardCircleIconSolid';
import DoorIcon from '@/components/icons/DoorIcon';
import ShowIcon from '@/components/icons/ShowIcon';
import ViewOffSlashIcon from '@/components/icons/ViewOffSlashIcon';
import { Button } from '@/components/ui/button';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SettlementsElement from './SettlementsElement';
import { useFinancesBalanceApi } from '@/features/finances/hooks/useFinancesBalanceApi';
import { cn } from '@/lib/utils';
import SettlementsDetails from './SettlementsDetails';
import { SettlementsType } from '../../types/finances-dto';

type Props = {
    className?: string;
    isMobile?: boolean;
};

const FinancesPageSettlements: FC<Props> = ({ className, isMobile }) => {
    const [showBalance, setShowBalance] = useState(true);
    const [showSettlementsDetails, setShowSettlementsDetails] = useState(false);
    const [settlementsType, setSettlementsType] = useState<SettlementsType>();

    const { t } = useTranslation();

    const { balanceData, isLoadingBalanceData } = useFinancesBalanceApi();

    const handleShowSettlementsDetails = (type: SettlementsType) => {
        setSettlementsType(type);
        setShowSettlementsDetails(true);
    };

    return (
        <div
            className={cn(
                'w-full p-6 flex flex-col gap-6 border border-popover-100 rounded-2.5xl bg-popover-10',
                isMobile && 'p-0 border-0 bg-popover-30 h-auto gap-4',
                className
            )}
        >
            <div className="flex items-center justify-between gap-4">
                <h4 className={cn('text-xl font-medium', isMobile && 'text-lg')}>
                    {t('main.finances.components.settlements.title')}
                </h4>
                <Button
                    variant="outline"
                    size="icon"
                    onClick={() => setShowBalance((prev) => !prev)}
                >
                    {showBalance ? <ShowIcon /> : <ViewOffSlashIcon />}
                </Button>
            </div>
            <div className="relative">
                <div className="h-full flex flex-col gap-4">
                    <div className={cn('flex gap-4', isMobile && 'flex-col gap-2')}>
                        <SettlementsElement
                            label="property"
                            value={balanceData?.property}
                            icon={DoorIcon}
                            balanceVisibility={showBalance}
                            onClick={() => handleShowSettlementsDetails(SettlementsType.Property)}
                            isLoading={isLoadingBalanceData}
                            isMobile={isMobile}
                            asset='property'
                        />
                        <SettlementsElement
                            label="otherService"
                            value={balanceData?.otherServices}
                            icon={DashboardCircleIconSolid}
                            onClick={() => handleShowSettlementsDetails(SettlementsType.OtherServices)}
                            balanceVisibility={showBalance}
                            isLoading={isLoadingBalanceData}
                            isMobile={isMobile}
                            asset='otherservices'
                        />
                    </div>
                </div>
            </div>
            {showSettlementsDetails && (
                <SettlementsDetails
                    onClose={() => setShowSettlementsDetails(false)}
                    filterType={settlementsType}
                    setFilterType={setSettlementsType}
                />
            )}
        </div>
    );
};

export default FinancesPageSettlements;
